import { Box, IconButton, Tooltip } from "@hightouch/htui";

import { SIDEBAR_TOGGLE_PROPS } from "src/components/layout/nav/mini-nav/mini-nav-context";
import { SidebarRightOpenIcon } from "src/ui/icons";

type Props = {
  /** The open panel's name, as in "Collapse <panelName> panel". */
  panelName: string;
  onCollapse: () => void;
  /** While the collapsed sidebar's toggle leads the crumb bar, it takes that toggle's small size, as the panel's open toggle there does. */
  isCrumbBarSize?: boolean;
  /** The sidebar's open state; the tooltip is suppressed while closed. */
  isOpen: boolean;
  keyboardShortcut?: string;
};

/**
 * The expanded sidebar's collapse control. The icon's chevron reveals on
 * hover through the `group` class, so the IconButton is rendered via Box to
 * take a className.
 */
export function AgentSidebarCollapseButton({
  panelName,
  onCollapse,
  isCrumbBarSize = false,
  isOpen,
  keyboardShortcut,
}: Props) {
  const label = `Collapse ${panelName} panel`;
  return (
    <Tooltip
      message={label}
      keyboardShortcut={keyboardShortcut}
      placement="bottom-start"
      // Hide the tooltip instantly when the sidebar isn't open
      // so that it doesn't flash a render elsewhere on the page.
      isDisabled={!isOpen}
    >
      <Box
        as={IconButton}
        className="group"
        aria-label={label}
        variant="tertiary"
        icon={SidebarRightOpenIcon}
        {...(isCrumbBarSize && SIDEBAR_TOGGLE_PROPS)}
        onClick={onCollapse}
      />
    </Tooltip>
  );
}
